import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Trophy, Clock, Gift } from "lucide-react";

const MEDAL_COLORS = ["#d4af37", "#c0c0c0", "#cd7f32"];

export default function Tournaments() {
  const { user } = useApp();
  const [data, setData] = useState({ tournament: null, leaderboard: [] });
  const [now, setNow] = useState(new Date());

  useEffect(() => { api.get("/tournaments/active").then(r => setData(r.data)).catch(() => {}); }, []);
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(id); }, []);

  const t = data.tournament;

  const fmtRemain = (endIso) => {
    const end = new Date(endIso);
    const ms = end - now;
    if (ms <= 0) return "ENDED";
    const d = Math.floor(ms / 86400000);
    const h = Math.floor((ms % 86400000) / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return `${d}d ${h}h ${m}m ${s}s`;
  };

  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-serif text-4xl gold-text flex items-center gap-3 mb-2"><Trophy/>Weekly Championship</h1>
      <p className="text-white/40 mb-6 text-sm">Heti verseny · Fizikai díjak (Steam Gift Card) · 100% legális, sweepstakes-mentes</p>

      {!t && <div className="lux-card p-10 text-center text-white/50">Nincs aktív verseny.</div>}

      {t && (
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
          {/* Leaderboard */}
          <div className="lux-card p-6">
            <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-[#d4af37]">{t.name}</div>
                <div className="text-xs text-white/40 mt-1">{t.description}</div>
              </div>
              <div className="text-right">
                <div className="text-[10px] uppercase tracking-widest text-white/40 flex items-center gap-1 justify-end"><Clock size={10}/>Ends in</div>
                <div className="font-serif text-xl text-[#d4af37]" data-testid="tournament-countdown">{fmtRemain(t.end)}</div>
              </div>
            </div>

            <div className="text-[10px] uppercase tracking-widest text-white/50 mb-2">Top 10 · Live</div>
            <div className="space-y-1">
              {data.leaderboard.length === 0 && <div className="text-white/30 text-center py-8">Még nincs játékos a tabellán — kezdj játszani és kerülj fel!</div>}
              {data.leaderboard.map((row) => {
                const isMe = user && row.user_id === user.user_id;
                return (
                  <div key={row.user_id} data-testid={`tournament-row-${row.place}`}
                       className={`flex items-center gap-3 p-3 rounded-md ${isMe ? "bg-[#d4af37]/10 border border-[#d4af37]/30" : "bg-black/30"}`}>
                    <div className="w-8 font-serif text-xl text-center" style={{ color: MEDAL_COLORS[row.place-1] || "#666" }}>
                      {row.place}
                    </div>
                    {row.picture ? <img src={row.picture} alt="" className="w-8 h-8 rounded-full"/> : <div className="w-8 h-8 rounded-full bg-white/10"/>}
                    <div className="flex-1 min-w-0">
                      <div className="truncate">{row.name} {isMe && <span className="text-[#d4af37] text-xs ml-1">(you)</span>}</div>
                      <div className="text-[10px]" style={{color: row.vip.color}}>{row.vip.name}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-serif text-base" style={{ color: row.score >= 0 ? "#34d399" : "#f87171" }}>
                        {row.score >= 0 ? "+" : ""}{Math.round(row.score).toLocaleString()} GC
                      </div>
                      <div className="text-[10px] text-white/40">{row.rounds} rounds</div>
                    </div>
                    {row.prize && <Gift size={16} className="text-[#d4af37]"/>}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Prizes */}
          <div className="lux-card p-6 h-fit">
            <h3 className="font-serif text-xl mb-4 flex items-center gap-2"><Gift className="text-[#d4af37]" size={18}/>Prize Pool</h3>
            <div className="space-y-2">
              {t.prizes.map(p => (
                <div key={p.place} data-testid={`prize-${p.place}`} className="flex items-center gap-3 p-2 rounded-md bg-black/30">
                  <div className="w-8 font-serif text-lg text-center" style={{ color: MEDAL_COLORS[p.place-1] || "#666" }}>{p.place}</div>
                  <div className="flex-1 text-sm">{p.prize}</div>
                  {p.value > 0 && <div className="text-xs text-white/40">~{p.value}€</div>}
                </div>
              ))}
            </div>
            <div className="mt-5 text-[10px] text-white/40 leading-relaxed">
              <strong>How it works:</strong> A score = nettó GC nyeremény (összes payout - összes tét) a verseny ideje alatt minden játékban. EUR tier (PC) tétek automatikusan átszámolódnak 1 PC = 400 GC arányban. Vasárnap 23:59 UTC-kor lezárul, a TOP 10 e-mailben kapja meg a Steam Gift Card kódot. Sweepstakes-mentes legális díjazás.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
